// Action Types
export const FETCH_ANALYTICS = 'dt/analytics/FETCH_ANALYTICS';
export const RECEIVE_ANALYTICS = 'dt/analytics/RECEIVE_ANALYTICS';
export const SET_ANALYTICS_LOADING = 'dt/analytics/SET_ANALYTICS_LOADING';
export const FETCH_EXPORT_ANALYTICS = 'dt/analytics/FETCH_EXPORT_ANALYTICS';

export const requestAnalytics = (query, panelId) => ({ type: FETCH_ANALYTICS, query, panelId });

export const fetchExportAnalytics = ({ query, exportCallback, panelId }) => ({
  type: FETCH_EXPORT_ANALYTICS,
  query,
  exportCallback,
  panelId,
});

export const receiveAnalytics = (data, query, total, panelId) => ({
  type: RECEIVE_ANALYTICS,
  data,
  tableType: query.tableType,
  offset: query.offset || 0,
  total,
  panelId,
});

export const setAnalyticsLoading = (loading, panelId) => ({
  type: SET_ANALYTICS_LOADING,
  loading,
  panelId,
});
